export const environment = {
  production: true,
  appVersion: '3.2.18',
  serverOrigin: 'https://buk.io',
  serviceOrigin: 'https://buk.io',
  dashboardOrigin: 'https://dashbaord.buk.io',
  wsServerOrigin: `https://ws.buk.io`,
  minRequiredIOSVersion: '1.1.6',
  minRequiredAndroidVersion: '1.1.6',
  amplitudeAPIKey: 'a777c3912cb793c7c9024f997454fb65',
};
